module.exports = __webpack_public_path__ + "img/Kerze_Bronze.f5893daf.png";